import React from 'react';
import Modal from "@/components/common/Modal";
import Newsletter, {NEWSLETTER_VARIANT} from "@/components/footer/Newsletter";
import {MODAL_COLOR_VARIANT} from "@/constants";
import styled from "styled-components";

const NewsletterModal = ({
	isOpen=false,
	handleClose = () => {},
	audioProps={},
	...props
}) => {
	return (
		<Modal
			colorVariant={MODAL_COLOR_VARIANT.LIGHT_DARK}
			isOpen={isOpen}
			handleClose={handleClose}
			{...props}
		>

			<Newsletter variant={NEWSLETTER_VARIANT.MODAL} />
		</Modal>
	)
}

export default NewsletterModal;